function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 0C4.91992 0 0 4.91992 0 11C0 17.0801 4.91992 22 11 22C17.0801 22 22 17.0801 22 11C22 4.91992 17.0801 0 11 0ZM11 20.6465C5.69336 20.6465 1.375 16.3066 1.375 11C1.375 5.69336 5.69336 1.375 11 1.375C16.3066 1.375 20.625 5.69336 20.625 11C20.625 16.3066 16.3066 20.6465 11 20.6465ZM11.752 11.6875H15.8125C16.1992 11.6875 16.5 11.3867 16.5 11C16.5 10.6133 16.1992 10.3125 15.8125 10.3125H6.1875C5.80078 10.3125 5.5 10.6133 5.5 11C5.5 11.3867 5.80078 11.6875 6.1875 11.6875H11.752Z",
  fill: "white"
});
function SvgDeletePersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePersonIcon);
export default __webpack_public_path__ + "static/media/deletePerson_icon.d3aacf09cd0a463fb2975cc9c5e70bed.svg";
export { ForwardRef as ReactComponent };